"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _core = require("@material-ui/core");
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _config = require("react-platform-specificity-of-product/dist/config");
var _urlJoin = _interopRequireDefault(require("url-join"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = require("@material-ui/core/styles");
var _RenderSpecificities = require("./RenderSpecificities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)({
  container: {
    marginTop: 25,
    marginBottom: 25
  },
  imageContainer: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    gap: "10px",
    marginBottom: 15
  },
  image: {
    width: "50px",
    height: "50px"
  }
});
var RenderSection = function RenderSection(_ref) {
  var item = _ref.item,
    fieldsDependToValueOfSpecificities = _ref.fieldsDependToValueOfSpecificities,
    conditionalSpecificities = _ref.conditionalSpecificities,
    isMd = _ref.isMd;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values;
  //styling
  var classes = useStyles();
  //returns section's specificities
  var sectionSpec = (0, _react.useMemo)(function () {
    return function (section, values) {
      return _lodash.default.uniqBy(values === null || values === void 0 ? void 0 : values.specificities.filter(function (productSpecificity) {
        var _productSpecificity$s, _productSpecificity$s2;
        return (productSpecificity === null || productSpecificity === void 0 ? void 0 : (_productSpecificity$s = productSpecificity.specificity) === null || _productSpecificity$s === void 0 ? void 0 : (_productSpecificity$s2 = _productSpecificity$s.section) === null || _productSpecificity$s2 === void 0 ? void 0 : _productSpecificity$s2.id) === (section === null || section === void 0 ? void 0 : section.id);
      }), "specificity");
    };
  });
  //sort sections specificities
  var sectionSpecificities = sectionSpec(item, values).filter(function (item) {
    return Object.keys(item.specificity).includes("section");
  }).sort(function (firstValue, secondValue) {
    var _firstValue$specifici, _secondValue$specific;
    return (firstValue === null || firstValue === void 0 ? void 0 : (_firstValue$specifici = firstValue.specificity) === null || _firstValue$specifici === void 0 ? void 0 : _firstValue$specifici.position) - (secondValue === null || secondValue === void 0 ? void 0 : (_secondValue$specific = secondValue.specificity) === null || _secondValue$specific === void 0 ? void 0 : _secondValue$specific.position);
  });
  //catch how many field per line in the section
  var sectionWidth = (item === null || item === void 0 ? void 0 : item.fields_per_line) === 0 ? 2 : item === null || item === void 0 ? void 0 : item.fields_per_line;
  if (!_lodash.default.isEmpty(sectionSpecificities)) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      xs: 12,
      md: 12,
      className: classes.container
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: 12,
      md: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.imageContainer
    }, !_lodash.default.isEmpty(item === null || item === void 0 ? void 0 : item.first_image) && /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _urlJoin.default)(_config.BASE_URL, item === null || item === void 0 ? void 0 : item.first_image["500x500"]),
      alt: "img",
      className: classes.image
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6"
    }, item === null || item === void 0 ? void 0 : item.name), (item === null || item === void 0 ? void 0 : item.description) !== "" && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
      leaveDelay: isMd && 2000,
      enterTouchDelay: isMd && 10,
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item === null || item === void 0 ? void 0 : item.description)
    }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      containter: true,
      xs: 12,
      md: 12,
      spacing: 0
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 12,
      md: 12,
      spacing: 2
    }, sectionSpecificities.map(function (productSpecificity, index) {
      return /*#__PURE__*/_react.default.createElement(_RenderSpecificities.RenderSpecificities, {
        key: index,
        conditionalSpecificities: conditionalSpecificities,
        fieldsDependToValueOfSpecificities: fieldsDependToValueOfSpecificities,
        productSpecificity: productSpecificity,
        fieldWidth: sectionWidth,
        isMd: isMd
      });
    }))));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
exports.RenderSection = RenderSection;